import {  z } from "zod";

export const ItensChecklistListaSchema = z.object({
  idItemchecklist: z.number().nullable().optional(),
  idChecklist: z.coerce.number().nullable().optional(),
  codigo: z.string(),
  descricao: z.string(),
});

export type ItensChecklistListaForm = z.infer<typeof ItensChecklistListaSchema>;
